module.exports = __webpack_public_path__ + "assets/25d4c4be5cf23f6262a253b112fb8252.mp3";